<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
    <p>{{ message }}</p>

    <div class="search-row">
        <!-- Search input -->
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search {{ entityType }}s</mat-label>
            <input (input)="filterEntities()" [(ngModel)]="searchText" matInput placeholder="Enter {{ entityType }} name">
            @if (searchText) {
                <button (click)="clearSearch()" aria-label="Clear" mat-icon-button matSuffix>
                    <mat-icon>close</mat-icon>
                </button>
            }
        </mat-form-field>

        @if (canRefresh) {
            <button
                    (click)="refreshEntities()"
                    [disabled]="isRefreshing"
                    [matTooltip]="'Refresh ' + entityType + 's'"
                    aria-label="Refresh list"
                    class="refresh-button"
                    mat-icon-button>
                <mat-icon [class.refreshing]="isRefreshing">refresh</mat-icon>
            </button>
        }
    </div>

    <!-- Entity list with radio buttons -->
    <div class="entity-list">
        <mat-radio-group [(ngModel)]="selectedEntityId" class="entity-radio-group">
            @for (entity of filteredEntities; track entity) {
                <div class="entity-item">
                    <mat-radio-button [value]="entity.id" class="entity-radio-button">
                        <div class="entity-details">
                            <!-- Display name for clients, ID for accounts -->
                            <div class="entity-name">{{ entityType === 'client' && entity.name ? entity.name : entity.id }}</div>
                            <div class="entity-info">
                                <!-- For clients, show enabled products -->
                                @if (entityType === 'client' && entity.enabledProducts) {
                                    @for (product of entity.enabledProducts; track product) {
                                        <mat-chip [ngClass]="getProductClass(product)">
                                            {{ getProductName(product) }}
                                        </mat-chip>
                                    }
                                }
                                <!-- For accounts, show access level -->
                                @if (entityType === 'account' && entity.access) {
                                    <mat-chip [ngClass]="getAccessClass(entity.access)">{{ entity.access }}</mat-chip>
                                }
                            </div>
                        </div>
                    </mat-radio-button>
                </div>
            }
        </mat-radio-group>

        <!-- No entities message -->
        @if (filteredEntities.length === 0) {
            <div class="no-entities-message">
                No {{ entityType }}s found matching your search.
            </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="onDismiss()" mat-button>Cancel</button>
    <button (click)="onConfirm()" [disabled]="!selectedEntityId" color="primary" mat-raised-button>Select</button>
</mat-dialog-actions>
